import { type MCPServerInfo } from '../../types';

const DrawioServer: MCPServerInfo = {
  serverId: 'DRAWIO',
  name: 'Draw.io',
  slug: 'drawio',
  description:
    'Draw.io MCP App Server - create and render diagrams inline in chat. Renders draw.io XML as interactive diagrams with zoom, pan, layers, and an "Open in draw.io" button for editing.',
  source: {
    sourceType: 'REMOTE_URL',
    mcpServerUrl: 'https://mcp.draw.io/mcp'
  },
  authenticationType: 'NONE',
  serverConfig: {
    required: [],
    properties: {}
  },
  installConfig: {
    required: [],
    properties: {}
  }
};

export default DrawioServer;
